@if (showLabel) {
  <label class='cpq-radio-button-group-title' >{{label.value ? label.value : (label.key | translate)}}</label>
}
<mat-radio-group [(ngModel)]="value" [name]="name" [required]="required" [disabled]="disabled">
  @for (button of buttons; track button) {
    <div>
      @if (button.visible) {
        <mat-radio-button [value]='button.value'>{{button.label.value ? button.label.value : (button.label.key | translate)}}</mat-radio-button>
      }
    </div>
  }
</mat-radio-group>